export const getLabelField = (item, labelField, labelFieldList = []) => {
  const attrs = item?.attributes || {};

  // Case-insensitive map: lowercase -> original key
  const ciMap = {};
  for (const k in attrs) {
    const lower = k.toLowerCase();
    if (!ciMap[lower]) ciMap[lower] = k;
  }

  // Helper to find value with case-insensitive key
  const findCI = name => {
    if (!name) return undefined;
    const lower = name.toLowerCase();
    const originalKey = Object.prototype.hasOwnProperty.call(attrs, name) ? name : ciMap[lower];
    return originalKey ? attrs[originalKey] : undefined;
  };

  // 1. Priority to labelField parameter (case-insensitive)
  if (labelField) {
    const val = findCI(labelField);
    if (val != null) return val;
  }

  // 2. Fallback: iterate labelFieldList (case-insensitive)
  for (const candidate of labelFieldList) {
    const val = findCI(candidate);
    if (val != null) return val;
  }

  return item.id;
};
